var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.t==='analytics')?_c('Analytics'):_vm._e(),(_vm.t==='setting')?_c('Setting'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }